import React, {useCallback, useMemo} from 'react';
import {Modal} from 'antd';
import {useSideBarModal} from '../../../../layout/common/useSideBarModal';
import ModelPublish from './ModelPublish';
import {ModelDetailActionProps} from '../../../actionMenuTypes';

export const useModelPublishSideBarModal = (props: Partial<ModelDetailActionProps>) => {
  const {model, onSuccess} = props;
  const {buttonRef, openModal, closeModal} = useSideBarModal(model?.uuid);

  const handleSuccess = useCallback(() => {
    closeModal();
    onSuccess?.();
  }, [closeModal, onSuccess]);

  const ModalComponent = useMemo(() => {
    return (
      model && (
        <Modal
          open={!!buttonRef}
          onCancel={closeModal}
          footer={null}
          title={null}
          width={640}
          centered
          closable={false}
          maskClosable={false}
          destroyOnHidden
          bodyStyle={{
            padding: '2.4rem 2.4rem 2rem 2.4rem',
          }}
        >
          {!!buttonRef && <ModelPublish model={model} onSuccess={handleSuccess} onCancel={closeModal} />}
        </Modal>
      )
    );
  }, [buttonRef, model, handleSuccess, closeModal]);

  return {
    openModal,
    ModalComponent,
  };
};
